/**
 * TESTING ONLY — mobile-OTP verification bypass allowlist.
 *
 * Accounts listed here skip the post-login mobile-verification gate even when
 * their profile reports `verify_mobile: "0"`. Nothing else about the flow
 * changes: every account NOT listed here is gated exactly as before.
 *
 * This exists for QA on legacy accounts that predate mobile verification and
 * would otherwise be trapped on /newVerification-code at every login. It is not
 * a product feature — remove entries once they are no longer needed for
 * testing.
 *
 * Consumed by:
 *   - src/app.jsx                                     (app-load gate)
 *   - src/Pages/public/authentication/newSign-in      (post-login gate)
 */

// Emails are compared case-insensitively and trimmed, so casing/whitespace in
// the profile response does not matter.
export const otpVerificationTestExceptionEmails = [
  'layne@projector.app',
];

/**
 * True when the given email is on the testing allowlist and should bypass the
 * mobile-OTP gate. Anything falsy or non-string is `false` — an unknown email
 * is never bypassed.
 */
export const isOtpVerificationTestException = (email) => {
  if (!email || typeof email !== 'string') return false;
  const normalized = email.trim().toLowerCase();
  if (!normalized) return false;
  return otpVerificationTestExceptionEmails.some(
    (allowed) => allowed.trim().toLowerCase() === normalized
  );
};

export default isOtpVerificationTestException;
